const style = {
  messageCell: {
    sx: {
      py: 4,
    },
  },
} as const;

export default style;
